/* istanbul ignore file */
export * from './DownloadsCard';
